import { Injectable } from '@angular/core';
import { BASE_API_URL, IGuestBanDetail, IReservation, ISuccessMessage, IUser } from '@curbnturf/entities';
import { CachedHttpClient } from '@curbnturf/network';
import { Observable } from 'rxjs';

const API_URL = BASE_API_URL + 'rating';

@Injectable({
  providedIn: 'root',
})
export class BanUserService {
  constructor(private http: CachedHttpClient) {}

  banGuest(user: IUser, reservation: IReservation): Observable<ISuccessMessage> {
    const guestId = user.id;
    return this.http.post<ISuccessMessage>(
      `${API_URL}/guest/${guestId}/ban`,
      {
        id: reservation.id,
      },
      undefined,
      {
        offlineCallback: () => ({ success: true }),
      },
    );
  }

  /** Admin-only: every ban a guest has received, across every host. */
  listBansForGuest(guestId: number): Observable<IGuestBanDetail[]> {
    return this.http.get<IGuestBanDetail[]>(`${API_URL}/guest/${guestId}/bans`);
  }

  /** Admin-only: reverse a mistaken ban. There's no host-facing undo — this is the only way back. */
  unbanGuest(guestId: number, reservationId: number): Observable<ISuccessMessage> {
    return this.http.delete<ISuccessMessage>(`${API_URL}/guest/${guestId}/ban/${reservationId}`);
  }
}
